<ul>
  <li
    class="rounded-0 d-flex align-items-center justify-content-center"
    [class.justify-content-center]="center()"
    (click)="toggleOpen()"
    (keydown.enter)="toggleOpen()"
    (keydown.space)="toggleOpen()"
    tabindex="0"
  >
    {{ selected.label || selected.value }}
  </li>

  @if(dropdownListOptions()?.length > 0 && open){
    @for(option of dropdownListOptions(); track $index;){
      @if(!isSelected($index)){
        <li
          (click)="listItemSelected($index)"
          (keydown.enter)="listItemSelected($index)"
          (keydown.space)="listItemSelected($index)"
          class="rounded-0 d-flex align-items-center"
          [class.justify-content-center]="center()"
          tabindex="0"
        >
          {{ option.label || option.value }}
        </li>
      }
    }
  }
</ul>
